import React from 'react';
import PropTypes from 'prop-types';
import RenderTextFieldRedux from './RenderTextFieldRedux';
import { Field, reduxForm } from 'redux-form';
import { Button } from '@material-ui/core';

const validate = values => {
    const error  = {}
    if (!values.data) {
        error.data = `El campo obligatorio`
    }
    return error
}
const DescriptionForm = props => {
    const { label, handleSubmit, valid, positive } = props
    return (
        <form onSubmit={ handleSubmit } >
            <Field
                name="data"
                id="data"
                component={ RenderTextFieldRedux }
                label={label}
                fullWidth
                multiline
                rows={3}
            />
            <br></br>
            <Button 
                variant="contained"
                color="primary"
                type="submit" 
                disabled={!valid}
            >
                {positive}
            </Button>
            <Button size="small" >Cancelar</Button>
        </form>
    );
};

DescriptionForm.propTypes = {
    label: PropTypes.string.isRequired,
    handleSubmit: PropTypes.func.isRequired,
};

const DescriptionFormRedux = reduxForm(
    {
      form: 'DescriptionForm',
      validate
    }
)(DescriptionForm)
export default DescriptionFormRedux

// export default DescriptionForm;